






































import { Component, Prop, Vue } from 'vue-property-decorator';
import Equation from '@/components/Equation.vue';
import { ClimbRateConstraint } from '@/interfaces/constraints';

@Component({
  components: {
  Equation,
  }
  })
export default class ClimbRateFields extends Vue {
  @Prop() constraint!: ClimbRateConstraint;
}
